import ReactPlayerLoader from '@brightcove/react-player-loader';
import React, { FC, useContext, useState } from 'react';

import { config } from '../../util/brightcove-api';

import { ReactComponent as WindowClose } from '../../assets/window-close-regular.svg';

export interface IVideoPlayerContext {
  hasVideoPlayer: boolean;
  isVideoPlaying: boolean;
  videoId: number | null;
  // Updater method that will be used in Provider
  setContext: (context: any) => void;
}

export const defaultVideoPlayerContext: IVideoPlayerContext = {
  hasVideoPlayer: false,
  isVideoPlaying: false,
  setContext: () => {
    // tslint:disable-next-line: no-console
    console.log('No context updater provided');
  },
  videoId: null,
};

export const VideoPlayerContext = React.createContext(
  defaultVideoPlayerContext
);

interface IVideoPlayer {
  hasAutoPlay?: boolean;
}

/**
 * VideoPlayer uses the brightcove api
 */
const VideoPlayer: FC<IVideoPlayer> = props => {
  const [state, setState] = useState({ isReady: false });
  const context = useContext(VideoPlayerContext);
  const videoPlayerRef = React.useRef<any>();

  /**
   *
   * Interact directly with the player after the player successfully mounts
   * https://player.support.brightcove.com/publish/brightcove-player-loader.html
   */
  const onSuccessHandler = ({ ref }: any) => {
    videoPlayerRef.current = ref;
    const player = ref.player();

    setState({ isReady: true });

    if (props.hasAutoPlay) {
      player.autoplay(true);
    }
  };

  const onClose = () => context.setContext({ hasVideoPlayer: false });

  return (
    <div className="bm-video">
      <ReactPlayerLoader
        accountId={config.accountId}
        videoId={context.videoId}
        attrs={{
          className: 'bm-video__player',
        }}
        onSuccess={onSuccessHandler}
      />
      {/* prevents close from loading before videoplayer */}
      {state.isReady && (
        <WindowClose className="bm-video__close-icon" onClick={onClose} />
      )}
    </div>
  );
};

export default VideoPlayer;
